import { Model } from 'redux-orm';

class Author extends Model {}
Author.modelName = 'Author';

export default Author;
